import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface HeroSectionProps {
  onScrollToPurchase: () => void;
}
export function HeroSection({
  onScrollToPurchase
}: HeroSectionProps) {
  return <section className="relative overflow-hidden bg-[#fafaf9] pt-12 pb-16 md:pt-20 md:pb-24" data-id="element-27">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-28">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-29">
          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex-1 text-center lg:text-left" data-id="element-30">
            <span className="inline-block px-4 py-1.5 mb-6 text-sm font-semibold tracking-wider text-[#2d5016] bg-[#e8f5e9] rounded-full" data-id="element-31">
              GUÍA DIGITAL 2026
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1a1a1a] leading-tight mb-6" data-id="element-32">
              ❌ Dejá de gastar en el vivero por errores evitables
            </h1>
            <p className="text-xl md:text-2xl text-[#4a7c2c] font-medium mb-6" data-id="element-33">
              🌱 Aprendé a hacer esquejes en casa, sin fallar, incluso si nunca
              lo hiciste antes
            </p>
            <p className="text-lg text-[#666666] mb-8 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-34">
              Una guía clara y práctica para multiplicar tus plantas con un
              método simple, probado y adaptado a Argentina.
            </p>

            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} onClick={onScrollToPurchase} className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-[#4a7c2c] rounded-full shadow-lg hover:bg-[#3d6624] transition-colors w-full md:w-auto" data-id="element-35">
              Quiero aprender a hacer esquejes
              <ArrowRight className="ml-2 w-5 h-5" data-id="element-36" />
            </motion.button>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex-1 w-full max-w-md lg:max-w-full" data-id="element-37">
            <div className="relative cursor-pointer group" onClick={onScrollToPurchase} data-id="element-38">
              <div className="absolute inset-0 bg-[#4a7c2c] rounded-2xl opacity-0 group-hover:opacity-10 transition-opacity duration-300 blur-xl" data-id="element-39"></div>
              <img src="https://cdn.magicpatterns.com/uploads/jNB6isM5tKdMXbQGVhtMPZ/MULTIPLICA_TUS_PLANTAS.png" alt="Guía Para Hacer Esquejes - Portada del Libro" className="relative w-full h-auto drop-shadow-2xl transform transition-transform duration-500 group-hover:-translate-y-2" data-id="element-40" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}